module.exports = __webpack_public_path__ + "static/media/iron-man-white-bg.ab156cca.png";